module.exports = __webpack_public_path__ + "assets/img/00008.0072092f.png";